import type { ReactNode } from "react";
import { Search } from "lucide-react";

/**
 * Standard toolbar shown above an overview list (Destinations,
 * Huntgroups, Applications, …): search input on the left, a count chip
 * in the middle and an optional trailing block (typically the view
 * toggle) on the right. Centralising this keeps the overview screens
 * visually aligned without duplicating the same flex/CSS in every page.
 */
export function OverviewToolbar({
  search,
  onSearch,
  placeholder = "Search",
  count,
  trailing,
}: {
  search: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  count?: { matched: number; total: number };
  trailing?: ReactNode;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginBottom: 12,
        flexWrap: "wrap",
      }}
    >
      <div style={{ position: "relative", flex: 1, maxWidth: 360 }}>
        <Search
          size={16}
          style={{
            position: "absolute",
            left: 12,
            top: "50%",
            transform: "translateY(-50%)",
            color: "var(--portal-muted)",
          }}
        />
        {/* autoFocus puts the cursor in the search box on every
            overview page so the user can start typing immediately
            without needing to click first. */}
        <input
          type="text"
          placeholder={placeholder}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          autoFocus
          className="portal-input-inline"
          style={{
            width: "100%",
            padding: "8px 12px 8px 36px",
            border: "1px solid var(--portal-border)",
            borderRadius: 6,
            fontSize: "0.95rem",
            fontFamily: "inherit",
            background: "#ffffff",
          }}
        />
      </div>
      {count && (
        <span style={{ color: "var(--portal-muted)", fontSize: "0.85rem" }}>
          {count.matched} of {count.total}
        </span>
      )}
      {trailing && <div style={{ marginLeft: "auto" }}>{trailing}</div>}
    </div>
  );
}
